import React, { useEffect, useState } from "react";
import { useIsFocused, useNavigation, useRoute } from "@react-navigation/native";
import i18n from "utils/i18n";
import _ from "lodash";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import LoadingComponent from "components/atoms/Loading";
import { FormStatus } from 'utils/constants/form-constants';
import GraphqlBuilder from "utils/request/graphql/builder";
import { tableConstants } from "utils/constants/constants";
import MutateTranslation from 'utils/mutate/translation'
import QueryManagementCompany from 'graphql/queries/management/QueryManagementCompany'
import MutationManagementCompany from 'graphql/mutations/management/MutationManagementCompany'
import CompanyData from 'scenes/management/company/components/company/data'
import CompanyDepartments from 'scenes/management/company/components/company/departments'
import TabbedContent from 'components/molecules/TabbedContent'
import ObjectCompany from 'utils/objects/company'
import HelperString from 'utils/helper-string'
import { AppRoutes } from 'navigations/app-routes'

const ManagementCompanyScene = () => {
	
	const navigation = useNavigation();
	const isFocused = useIsFocused();
	const route = useRoute();
	
	const [ loading, setLoading ] = useState( true )
	const [ company, setCompany ] = useState( {} )
	
	const companyGuid = _.get( route.params, 'companyGuid', null );
	const companyExists = companyGuid !== null;
	
	const fetchCompany = () => {
		if( companyGuid !== null ) {
			new GraphqlBuilder()
				.addQuery( 'query', QueryManagementCompany, {
					guid: companyGuid
				})
				.setResultPath( ['query', 'company'], {} )
				.setOnSuccess( result => {
					setLoading( false )
					setCompany( result )
				})
				.setOnError( setLoading.bind( this, false ) )
				.execute()
			
			return;
		}
		
		setLoading( false )
		setCompany( ObjectCompany.defaults )
	}
	
	const saveForm = ( values, { callback } = {} ) => {
		new GraphqlBuilder()
			.addQuery( 'mutation', MutationManagementCompany, values )
			.setResultPath( ['mutation', 'company'], {} )
			.setOnStart( () => {
				callback( FormStatus.LOADING )
			})
			.setOnSuccess( ( result ) => {
				MutateTranslation.mutate( tableConstants.COMPANIES, result.guid, values, {
					callbackSuccess: ( t ) => {
						callback( FormStatus.SUCCESS )
						
						navigation.replace( AppRoutes.MANAGEMENT_COMPANY_COMPANIES_VIEW, {
							companyGuid: result.guid
						});
					},
					callbackError: () => {
						callback( FormStatus.ERROR )
					}
				} )
			})
			.setOnError( ( result ) => {
				callback( FormStatus.ERROR )
			})
			.execute()
	}
	
	useEffect( () => {
		return fetchCompany();
	}, [ isFocused, companyGuid ] )
	
	if( loading ) {
		return (
			<LoadingComponent />
		)
	}
	
	const tabBarItems = []
	
	// Data
	tabBarItems.push({
		key: 'data',
		text: i18n.t( 'management:form_block.title_default' ),
		scene: ( props ) => {
			return (
				<CompanyData
					key={ HelperString.hash( 'company-data', company ) }
					{ ...props }
					company={ company }
					saveForm={ saveForm }
				/>
			);
		}
	});
	
	// Departments
	if( companyExists ) {
		tabBarItems.push({
			key: 'departments',
			text: i18n.t('management:form.departments.title'),
			scene: ( props ) => {
				return (
					<CompanyDepartments
						key={ HelperString.hash( 'company-departments', company ) }
						{ ...props }
						company={ company }
					/>
				);
			}
		});
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t('management:pages.company.company.title') }
				topNavigation={true}
				showBackButton={true}>
				
				<TabbedContent
					items={ tabBarItems }
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

export default ManagementCompanyScene
